import React, { useState, useContext } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FuncionesContext, { getAtributo } from "../context/FuncionesContext";

import PropTypes from "prop-types";
//import { autocompleteClasses } from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import ListSubheader from "@mui/material/ListSubheader";
//import Popper from "@mui/material/Popper";
import { useTheme /*styled*/ } from "@mui/material/styles";
import { VariableSizeList } from "react-window";
import Typography from "@mui/material/Typography";

import { matchSorter } from "match-sorter";
import { useRefDataStore } from "../../..";
import Nullifier from "./Nullifier";

const LISTBOX_PADDING = 8; // px

function renderRow(props) {
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: style.top + LISTBOX_PADDING,
  };

  if (dataSet.hasOwnProperty("group")) {
    return (
      <ListSubheader key={dataSet.key} component="div" style={inlineStyle}>
        {dataSet.group}
      </ListSubheader>
    );
  }

  return (
    <Typography component="li" {...dataSet[0]} noWrap style={inlineStyle}>
      {dataSet[1]}
    </Typography>
  );
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...other } = props;
  const itemData = [];
  children.forEach((item) => {
    itemData.push(item);
    itemData.push(...(item.children || []));
  });

  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"), {
    noSsr: true,
  });

  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (child.hasOwnProperty("group")) {
      return 48;
    }
    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

ListboxComponent.propTypes = {
  children: PropTypes.node,
};

// const StyledPopper = styled(Popper)({
//   [`& .${autocompleteClasses.listbox}`]: {
//     boxSizing: "border-box",
//     "& ul": {
//       padding: 0,
//       margin: 0,
//     },
//   },
// });

export default function Virtualize({
  cab,
  data,
  // context,
  // indiceData,
  campokey,
  id_elemento,
}) {
  const { superSubmit } = useContext(FuncionesContext);

  //const { Dispatch } = useContext(context);

  const [v, setStore] = useRefDataStore((s) => s[data._key + campokey]);
  const [update_id] = useRefDataStore(
    (s) => s[data._key + cab.update_id_alias]
  );

  const [value, setValue] = useState(
    cab.opciones?.filter((o) => o.value === v).pop()?.label
  );

  const [inputValue, setInputValue] = React.useState("");
  const [updateId, setUpdateId] = useState(update_id);

  const handleCancelar = () => { };

  const handleChangeValue = async (newValue) => {
    const valor = newValue.value; //newValue { value, label }

    const { id_a } = cab;

    superSubmit({ valor, id_a, update_id: updateId, handleCancelar, cab, data })
      .then((result) => {
        setStore({ [data._key + campokey]: newValue.label });
        if (!updateId) {
          setStore({
            [data._key + cab.update_id_alias]: result.data.registro.id,
          });
          setStore({ [data._key + campokey + "_label"]: newValue.label });
          setUpdateId(result.data.registro.id);
        }
        setValue(newValue.label);
      })
      .catch((err) => {
        console.log("Cancelado ", err);
      });
  };

  const filterMatch = (option, { inputValue }) => {
    const minValuelength = cab.autocompletar_minimo ?? 4;
    const minValueReached = inputValue?.length > minValuelength;
    if (minValueReached) {
      return matchSorter(option, inputValue, { keys: ["label", "codref"] });
    }
    return [];
  };
  // setStore({ [data._key + campokey + "_label"]: inputValue });

  const permite_null = getAtributo("permite_null", data, cab) === "s";

  // NUEVO: ícono obligatorio según atributo
  const icono_obligatorio =
    getAtributo("icono_obligatorio", data, cab) === "s";

  return (
    <>
      <div className="vista_label">
        {cab.nombre ? (
          <p
            style={{ position: "relative", width: "max-content" }}
          >
            {cab.nombre}:
          </p>
        ) : (
          <></>
        )}
      </div>

      {/* Contenedor: Autocomplete + asterisco + 'x' (si permite_null) */}
      <div style={{ display: "flex", alignItems: "center", gap: "4px", width: "100%" }}>
        <Autocomplete
          value={value}
          id={id_elemento}
          sx={{ width: "100%" }}
          disableListWrap
          disableClearable
          size="small"
          className={` ${data[cab.id_a + "_className"] ?? cab.className}`}
          filterOptions={filterMatch}
          ListboxComponent={ListboxComponent}
          options={cab.opciones.sort((a, b) =>
            a.label.toUpperCase().localeCompare(b.label.toUpperCase())
          )}
          groupBy={(option) => {
            return option.label[0].toUpperCase();
          }}
          renderInput={(params) => (
            <TextField inputProps={{ className: "input_altura" }} {...params} label={cab.placeholder} className="autocompletar_text_field"/>
          )}
          renderOption={(props, option) => [props, option.label]}
          // TODO: Post React 18 update - validate this conversion, look like a hidden bug
          renderGroup={(params) => params}
          onChange={(event, newValue) => handleChangeValue(newValue)}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
          disabled={getAtributo("disabled", data, cab) === "s"}
        />

        {/* Asterisco por icono_obligatorio (derecha del input) */}
        {icono_obligatorio && (
          <span className="icono_obligatorio">*</span>
        )}

        {permite_null ? (
          <Nullifier
            onClick={() => handleChangeValue({ value: null })}
            className="columna_input_date_null"
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
